let dpis_list = [
    {
        question: "SPECIFICATIONS FOR THE DRUG PRODUCT",
        answer:
            <ul>
                <li>Description</li>
                <li>Identification (Primary and secondary)</li>
                <li>Water or Moisture Content</li>
                <li>Net Content (Fill) Weight (Device-metered)</li>
                <li>Drug Content (Assay)</li>
                <li>Impurities and Degradation Products</li>
                <li>Dose Content Uniformity</li>
                <li>Dose Content Uniformity Through Container Life</li>
                <li>Particle Size Distribution of Emitted Dose</li>
                <li>Foreign particulate matter</li>
                <li>Microscopic Evaluation</li>
            </ul>
    },
    {
        question: "DRUG PRODUCT CHARACTERIZATION STUDIES FOR SUBMISSION",
        answer:
            <ul>
                <li>Determination of Appropriate Storage Conditions</li>
                <li>Stability of Primary (Unprotected) Package</li>
                <li>Effect of Varying Flow Rates</li>
                <li>Effect of Storage on the Particle Size Distribution</li>
                <li>Dose Build-up and Flow Resistance</li>
                <li>Effect of Orientation
                </li>
                <li>In Vitro Dose Proportionality
                </li>
                <li>Effect of Patient Use / In-use stability (as per PIL)
                </li>
                <li>Effect of Moisture
                </li>
                <li>Photo stability
                </li>
                <li>Profiling of Doses Near Device Exhaustion
                </li>
                <li>Priming (For Device metered)
                </li>
                <li>Fill Weight
                </li>
                <li>Device Ruggedness
                </li>
                <li>Cleaning Instructions
                </li>
            </ul>
    },
    {
        question:
            "IN-VITRO BIO- EQUIVALENCE WITH STATISTICAL ANALYSIS (FOR SUBMISSION)",
        answer:
            <ul>
                <li>APSD (test and Reference) with critical stage PBE
                </li>
                <li>Single actuation content (test and Reference) (SAC) with PBE
                </li>
                <li>Q1-Q2 comparison
                </li>
            </ul>
    },
    {
        question:
            "INNOVATIVE IN-VITRO TESTING",
        answer:
            <ul>
                <li>BRS 3000 -Improving IVIVCs for DPIs</li>
                <li>Dissolution Testing with and without using anatomical throat
                </li>
                <li>APSD study with anatomical throat
                </li>
                <li>Surface area
                </li>
                <li>Surface energy</li>
                <li>Powder Rheology (FT4)</li>
                <li>Particle Size and shape</li>
            </ul>
    },
];
export default dpis_list;